import { COMMENT_VIEW, AI_VIEW } from 'components/DocRightRail/Constants'
import { useArticleView } from 'providers/ArticleViewProvider/ArticleViewProvider'
import { ArticleFlat, ArticleView } from 'types'
import { isExternalResource } from 'utils/articleUtils'

type Props = {
  article: ArticleFlat
}

export const useAvailableTabs = ({ article }: Props) => {
  const articleView = useArticleView()
  const isArticleExternalResource = isExternalResource(article)

  return {
    [AI_VIEW]: !isArticleExternalResource && articleView === ArticleView.Editing,
    [COMMENT_VIEW]: articleView === ArticleView.Editing || articleView === ArticleView.Commenting,
  }
}
